import { useEffect, useRef } from 'react';

export default function useMailboxEventHandlers(handler: () => void) {
  const handlerRef = useRef(handler);
  useEffect(() => {
    handlerRef.current = handler;
  });

  useEffect(() => {
    const mailbox = Office.context?.mailbox;
    const stableHandler = () => handlerRef.current();

    const onError = (result: Office.AsyncResult<void>) => {
      if (result.status === Office.AsyncResultStatus.Failed) {
        console.error('Failed to add mailbox event handler:', result.error);
      }
    };

    mailbox?.addHandlerAsync(
      Office.EventType.ItemChanged,
      stableHandler,
      onError,
    );

    mailbox?.addHandlerAsync(
      Office.EventType.SelectedItemsChanged,
      stableHandler,
      onError,
    );

    return () => {
      mailbox?.removeHandlerAsync(Office.EventType.ItemChanged);
      mailbox?.removeHandlerAsync(Office.EventType.SelectedItemsChanged);
    };
  }, []);
}
